exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".drawable-video-player__player-canvas-wrapper{position:relative}\n", ""]);
